import {
  Component,
  ElementRef,
  inject,
  NgZone,
  PLATFORM_ID,
  ViewChild,
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewSidebarComponent } from '../sidebar-new/sidebar-addtional/new-sidebar/new-sidebar.component';
import { IconsComponent } from '../editor/additional/icons/icons.component';
import { ToolbarComponent } from '../editor/additional/toolbar/toolbar.component';
import { EmptyContentComponent } from '../editor/additional/placeholders/empty-content.component';
import { registerErrorSpanBlot } from '../editor/additional/custom-blots';
import { isPlatformBrowser } from '@angular/common';
import { UploadFileComponent } from '../editor/additional/placeholders/upload-file.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ApidataService } from '../apidata.service';
import { ModalComponent } from '../editor/additional/modals/modal.component';
import { TabviewSidebarComponent } from '../tabview-sidebar/tabview-sidebar.component';
import { environment } from '../../environments/environments';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { saveAs } from 'file-saver';
import { Subject, takeUntil } from 'rxjs';
import r from '../g-disable';

let headers = new HttpHeaders({ Authorization: environment.AuthorizationGIN });
headers = headers.set('Content-Type', 'application/json; charset=utf-8');

@Component({
  standalone: true,
  selector: 'app-plagiarismchecker',
  templateUrl: './plagiarismchecker.component.html',
  styleUrls: ['./plagiarismchecker.component.css'],
  imports: [
    CommonModule,
    NewSidebarComponent,
    IconsComponent,
    ToolbarComponent,
    EmptyContentComponent,
    UploadFileComponent,
    NgCircleProgressModule,
    FormsModule,
    ModalComponent,TabviewSidebarComponent,IconsFreeToolsComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PlagiarismcheckerComponent implements AfterViewInit, OnDestroy {
  @ViewChild('editor', { static: true }) editorElement!: ElementRef;
  @ViewChild('editorToolbar', { static: true }) toolbarElement!: ElementRef;

  private platformId = inject(PLATFORM_ID);
  private ngZone = inject(NgZone);

  private plagiarismRequestSignal$ = new Subject<void>();

  Object = Object;
  innerWidth: number = window.innerWidth;

  quillEditor: any;

  editorEnabled: boolean = true;
  editorLoaded: boolean = false;
  resultsCollapsed: boolean = false;

  authLimits = {
    guest: {
      words: 1000,
    },
    auth: {
      words: 1000,
    },
    pro: {
      words: 10000,
    },
  };
  authTitle: string;
  authState: 'guest' | 'auth' | 'pro' = 'auth';

  doc_id: string;
  profile_id: string = localStorage.getItem('profile_id') || '1';

  exclude_url: string = '';

  editorState = {
    words: 0,
    characters: 0,
    content_id: null,
    sentences: {},
    plagiarised: {},
    listing: [],
    score: 0,
    state: 'initial',
    valid_sentences: 0,
  };

  constructor(
    private apiDataService: ApidataService,
    private https: HttpClient,
    private route: ActivatedRoute,
    private router: Router
  ) {
    //
  }

  ngAfterViewInit() {
    this.loadEditor();

    this.route.queryParams.subscribe((params) => {
      this.doc_id = params['doc'];
    });

    if (isPlatformBrowser(this.platformId)) {
      r();

      if (this.profile_id !== '1') {
        this.apiDataService
          .getUserProfileContents(this.profile_id)
          .subscribe((data) => {
            this.authTitle = data.contents[0][5];
            if (
              data.contents[0][5] === 'premium_user' ||
              data.contents[0][5] === 'free_trial'
            ) {
              this.authState = 'pro';
            } else {
              this.authState = 'auth';
            }
          });
      } else {
        this.authState = 'guest';
      }

      setTimeout(() => {
        if (
          localStorage.getItem('editorValueAI') &&
          localStorage.getItem('editorValueAI') !== '<p><br></p>'
        ) {
          const content = new DOMParser()
            .parseFromString(localStorage.getItem('editorValueAI'), 'text/html')
            .body.textContent.trim();
          if (content.length) {
            this.quillEditor.root.innerHTML =
              localStorage.getItem('editorValueAI');

            setTimeout(() => {
              this.handleCheckPlagiarism();
            }, 0);
          } else {
            this.editorEnabled = false;
          }
          localStorage.removeItem('editorValueAI');
        } else {
          this.editorEnabled = false;
          this.apiDataService
            .onloadcontentresquest(this.profile_id, this.doc_id)
            .subscribe((data) => {
              const content = new DOMParser()
                .parseFromString(data.outConts, 'text/html')
                .body.textContent.trim();
              if (content.length) {
                this.quillEditor.root.innerHTML = data.outConts;
                this.editorEnabled = true;
              }
            });
        }
      }, 100);
    }
  }

  ngOnDestroy() {
    this.plagiarismRequestSignal$.next();
  }

  handleCheckPlagiarism() {
    if (this.editorState.words > this.authLimits[this.authState].words) {
      document.getElementById(
        'content-exceeds-words-limit-modal'
      ).style.display = 'grid';
      this.quillEditor.enable();
      return;
    }

    this.removeErrorHighlightsFromText();

    this.editorState.plagiarised = {};
    this.editorState.sentences = {};
    this.editorState.score = 0;
    this.editorState.state = 'loading';

    const text = btoa(
      unescape(encodeURIComponent(this.quillEditor.getText().trim()))
    );

    this.https
      .post(
        `${environment.API_URL}/api/plagBreakData`,
        {
          access_token: 'KW#2TI7G30fA(V',
          text,
          profile_id: localStorage.getItem('profile_id') ?? '1',
        },
        { headers }
      )
      .pipe(takeUntil(this.plagiarismRequestSignal$))
      .subscribe((data) => {
        const { sentences, sentence_ids, content_id, valid_sentences } =
          data['data']['RES'];

        this.editorState.sentences = this.createSentencesHashmap(
          sentences,
          sentence_ids
        );
        this.editorState.content_id = content_id;

        this.editorState.valid_sentences = valid_sentences;

        if (valid_sentences) {
          Object.keys(this.editorState.sentences).forEach((sentence) => {
            this.checkPlagiarismBySentence(sentence.toString());
          });
        }
      });
  }

  checkPlagiarismBySentence(sentence_id: string) {
    this.https
      .post(
        `${environment.API_URL}/api/checkPlagiarism`,
        {
          access_token: 'KW#2TI7G30fA(V',
          content_id: this.editorState.content_id.toString(),
          sentence_id,
          exclude: this.exclude_url,
        },
        { headers }
      )
      .pipe(takeUntil(this.plagiarismRequestSignal$))
      .subscribe((data) => {
        this.editorState.valid_sentences -= 1;
        const d = data['data'][0];

        if (d.is_plag === '1') {
          this.editorState.plagiarised[sentence_id] = d.details;

          this.calculateScore();
          this.highlightMatches(d.details.query, sentence_id);
          this.pushToListing(d);
        }

        if (!this.editorState.valid_sentences) {
          this.editorState.state = 'initial';
          this.saveEditorText();
        }
      });
  }

  pushToListing(d) {
    this.editorState.listing.push({
      index: d.query_id,
      matchesurl: d.details.sources,
      unique: d.details.unique,
      url: d.details.webs,
      sentence: d.details.query,
      sourcestotal: d.details.sources,
      similarity_score: d.details.similarity_score,
    });
  }

  saveEditorText() {
    const content = this.quillEditor.root.cloneNode(true) as HTMLElement;
    const highlights = content.querySelectorAll('span');

    highlights.forEach((highlight) => {
      const parent = highlight.parentElement;
      while (highlight.firstChild) {
        parent.insertBefore(highlight.firstChild, highlight);
      }
      parent.removeChild(highlight);
    });

    this.apiDataService
      .auto_saved_Api(
        this.profile_id,
        'Plagiarism Checker',
        'Plagiarism Checker',
        content.innerHTML,
        this.doc_id,
        'plagiarism-checker'
      )
      .subscribe();
  }

  calculateScore() {
    this.editorState.score = Math.floor(
      (this.Object.keys(this.editorState.plagiarised).length /
        this.Object.keys(this.editorState.sentences).length) *
        100
    );
  }

  createSentencesHashmap(sentences, sentence_ids) {
    let hashmap = {};

    sentence_ids.forEach((id, index) => {
      hashmap[id] = sentences[index];
    });

    return hashmap;
  }

  highlightMatches(query, sentence_id) {
    const root = this.quillEditor.root;

    type TextPosition = {
      node: Text;
      offset: number;
    };

    const flatText: string[] = [];
    const positions: TextPosition[] = [];

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) {
      const node = walker.currentNode as Text;
      const text = node.nodeValue || '';
      for (let i = 0; i < text.length; i++) {
        flatText.push(text[i]);
        positions.push({ node, offset: i });
      }
    }

    const fullText = flatText.join('');

    let start = 0;
    while ((start = fullText.indexOf(query, start)) !== -1) {
      const end = start + query.length;

      const range = document.createRange();
      const startPos = positions[start];
      const endPos = positions[end - 1];

      try {
        range.setStart(startPos.node, startPos.offset);
        range.setEnd(endPos.node, endPos.offset + 1);

        const span = document.createElement('span');
        span.className = 'highlight-plagiarized';
        span.id = `HL_${sentence_id}-HTPD2M`;
        span.style.borderBottom = '2px solid #df2148';
        range.surroundContents(span);
      } catch (e) {
        console.warn('Skipping invalid range:', e);
      }

      start = end;
    }
  }

  loadEditor() {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        import('ngx-quill').then((module) => {
          import('quill').then((quillModule) => {
            this.ngZone.run(() => {
              this.initializeEditor(module, quillModule);
            });
          });
        });
      });
    }
  }

  initializeEditor(quillModule: any, quillImport: any) {
    const Quill = quillImport.default;
    registerErrorSpanBlot(Quill);
    this.editorLoaded = true;

    const editorConfig = {
      modules: {
        toolbar: {
          container: this.toolbarElement.nativeElement,
        },
      },
      placeholder: '',
      theme: 'snow',
    };

    this.quillEditor = new Quill(
      this.editorElement.nativeElement,
      editorConfig
    );

    this.quillEditor.root.id = 'mm';

    this.addEventListeners();
  }

  private addEventListeners() {
    if (!this.quillEditor) return;

    const q = this.quillEditor;

    q.on('text-change', () => {
      this.editorEnabled = true;
      this.computeWordsAndCharactersCount();
    });

    q.root.addEventListener('blur', () => {
      this.editorEnabled =
        !!this.editorState.characters ||
        this.quillEditor.root.innerHTML !== '<p><br></p>';
    });

    q.root.addEventListener('click', (event: MouseEvent) => {
      this.handleEditorClick(event);
    });

    q.root.addEventListener('paste', () => {
      q.root.querySelectorAll('img').forEach((img) => img.remove());
      q.root
        .querySelectorAll('[style]')
        .forEach((el) => el.removeAttribute('style'));
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.innerWidth = (event.target as Window).innerWidth;
  }

  handleEditorClick(event: MouseEvent) {
    const el = event.target as HTMLElement;

    if (!el.classList.contains('highlight-plagiarized')) return;

    this.quillEditor.root
      .querySelectorAll('.highlighted-plag')
      .forEach((el) => {
        el.classList.remove('highlighted-plag');
      });

    el.classList.add('highlighted-plag');

    document.querySelectorAll('.expanded').forEach((el) => {
      el.classList.remove('expanded');
      el.querySelector('button')?.classList.remove('rotate-180');
    });

    const li = document.querySelector(`[data-target="${el.id}"]`);

    this.resultsCollapsed = false;

    li.classList.add('expanded');
    li.querySelector('button')?.classList.add('rotate-180');
    li.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  renderEditor() {
    this.editorEnabled = true;

    this.quillEditor.root.focus();
  }

  copyToClipboard(event, text: string) {
    navigator.clipboard.writeText(text);

    const el = (event.target as HTMLElement)
      .closest('button')
      .querySelector('.tooltip-content') as HTMLElement;

    el.innerText = 'Copied!';
    setTimeout(() => {
      el.innerText = 'Copy';
    }, 2000);
  }

  clearEditor(event) {
    this.quillEditor.setText(null);
    this.editorState.words = 0;
    this.editorState.characters = 0;
    this.editorEnabled = false;
    this.editorState.content_id = null;
    this.exclude_url = '';
    this.plagiarismRequestSignal$.next();
    this.editorState.state = 'initial';
    this.saveEditorText();

    const el = (event.target as HTMLElement)
      .closest('button')
      .querySelector('.tooltip-content') as HTMLElement;

    el.innerText = 'Cleared!';
    setTimeout(() => {
      el.innerText = 'Clear';
    }, 2000);
  }

  computeWordsAndCharactersCount() {
    const editorText = this.quillEditor.getText().trim();
    const words = editorText.length ? editorText.split(/\s+/) : [];

    this.editorState.words = words.length;
    this.editorState.characters = editorText.length;
  }

  handleResultToggle(event: Event) {
    const clicked = (event.target as HTMLElement).closest('button');

    if (clicked.classList.contains('rotate-180')) {
      clicked.closest('li')?.classList.remove('expanded');
      clicked.classList.remove('rotate-180');
      document
        .getElementById(clicked.dataset['target'])
        .classList.remove('highlighted-plag');

      return;
    }

    const t = document.getElementById(clicked.dataset['target']);

    t.classList.add('highlighted-plag');
    t.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });

    const expanded = document.querySelectorAll('.expanded');
    expanded.forEach((el: HTMLElement) => {
      el.classList.remove('expanded');
      el.querySelector('button')?.classList.remove('rotate-180');
      document
        .getElementById(el.dataset['target'])
        .classList.remove('highlighted-plag');
    });

    const li = clicked.closest('li');

    li.classList.add('expanded');
    clicked.classList.add('rotate-180');
  }

  siteTitle(url: string): string {
    try {
      if (!url.startsWith('http')) {
        url = 'https://' + url;
      }

      const hostname = new URL(url).hostname.replace(/^www\./, '');
      const parts = hostname.split('.');

      if (parts.length >= 3) {
        const last = parts[parts.length - 1];
        const secondLast = parts[parts.length - 2];
        const thirdLast = parts[parts.length - 3];

        if (secondLast.length <= 3 && last.length <= 3) {
          return `${thirdLast}.${secondLast}.${last}`;
        }
      }

      if (parts.length >= 2) {
        return parts.slice(-2).join('.');
      }

      return hostname;
    } catch {
      return '';
    }
  }

  f(number: number): string {
    return number.toLocaleString();
  }

  invokeModal(event: Event) {
    const targetId = (event.target as HTMLElement).closest('button').dataset[
      'target'
    ];

    document.getElementById(targetId).style.display = 'grid';
  }

  dismissModal(event: Event) {
    (
      (event.target as HTMLElement).closest('.wrapper') as HTMLElement
    ).style.display = 'none';
  }

  downloadReport() {
    this.https
      .post(
        `${environment.API_URL}/api/plagReport`,
        {
          plagiarized: this.editorState.score,
          unique: 100 - this.editorState.score,
          word: this.editorState.words,
          characters: this.editorState.characters,
          editor_content: this.quillEditor.root.innerHTML,
          plagListings: this.editorState.listing,
          exclude: [{ url: this.exclude_url }],
        },
        { headers, responseType: 'blob' }
      )
      .subscribe((response: Blob) => {
        saveAs(response, `plagiarism-report-${this.doc_id}.pdf`);
      });
  }

  removeErrorHighlightsFromText() {
    const highlights = this.quillEditor.root.querySelectorAll('span');

    highlights.forEach((highlight) => {
      let parent = highlight.parentNode;
      while (highlight.firstChild) {
        parent.insertBefore(highlight.firstChild, highlight);
      }
      parent.removeChild(highlight);
    });
  }

  makeItUnique() {
    const clone = this.quillEditor.root.cloneNode(true) as HTMLElement;
    clone.querySelectorAll('span').forEach((el) => {
      const parent = el.parentElement;
      while (el.firstChild) {
        parent.insertBefore(el.firstChild, el);
      }
      parent.removeChild(el);
    });
    const text = clone.innerHTML;
    localStorage.setItem('editorValueAI', text);
    this.router.navigate(['/article'], {
      queryParams: { doc: this.doc_id },
    });
  }
}
